import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { List, Plus, Trash2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function StoreCategories() {
  const { user } = useAuth();
  const [cats, setCats] = useState(null);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!user?.user_id) return;
    try { setCats(await api(`/sellers/${user.user_id}/categories`)); } catch { setCats([]); }
  }, [user?.user_id]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!name.trim()) return toast.error("أدخل اسم القائمة");
    setBusy(true);
    try { await api("/categories", { method: "POST", body: JSON.stringify({ name: name.trim() }) }); setName(""); load(); toast.success("تمت الإضافة"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const remove = async (id) => {
    if (!window.confirm("حذف القائمة؟")) return;
    try { await api(`/categories/${id}`, { method: "DELETE" }); load(); } catch (e) { toast.error(e.message); }
  };

  if (!cats) return <Loader />;

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="قوائم متجري" />
      <div className="flex items-center gap-2 mb-4">
        <input data-testid="store-cat-input" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="اسم القائمة (مثال: أحذية رجالية)" className="flex-1 bg-white rounded-xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
        <button data-testid="store-cat-add" disabled={busy} onClick={add} className="w-12 h-12 rounded-xl bg-[#FF3D5A] text-white flex items-center justify-center"><Plus size={22} /></button>
      </div>
      {cats.length === 0 ? <EmptyState icon={List} title="لا توجد قوائم بعد — أضف قائمتك الأولى" /> : (
        <div className="space-y-2">
          {cats.map((c) => (
            <div key={c.category_id} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2]">
              <List size={18} className="text-[#FF3D5A]" />
              <span className="flex-1 font-bold text-[#161629]">{c.name}</span>
              <button data-testid={`store-cat-del-${c.category_id}`} onClick={() => remove(c.category_id)}><Trash2 size={18} className="text-[#FF3D5A]" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
